module.exports = __webpack_public_path__ + "img/shareBg.a5eeb93e.png";